module.exports = {
    //更新公会列表，请求公会列表时候返回
    UpdateGuildList: "UpdateGuildList"

    //单个公会状态改变
    , UpdateGuildItemEvent: "UpdateGuildItemEvent"

    //更新自己公会的基础信息
    , UpdateMyInfoEvent: "UpdateMyInfoEvent"

    //更新自己公会成员列表
    , UpdateMyMemberListEvent: "UpdateMyMemberListEvent"

    //更新自己公会单个成员的数据，主要是职位等
    , UpdateMyMemberItemEvent: "UpdateMyMemberItemEvent"

    //更新副会长数量的事件，策划这个比较蛋疼的
    , UpdateAssistantNumEvent: "UpdateAssistantNumEvent"

    //捐献次数更新
    , UpdateDonateInfo: "UpdateDonateInfo"

    //更新申请列表
    , UpdateApplyListInfo: "UpdateApplyListInfo"

    //公会更新红点事件
    , UpdateGuildRedStatus: "UpdateGuildRedStatus"

    // 更新捐献宝箱状态
    , UpdateDonateBoxStatus: "UpdateDonateBoxStatus"

    //公会活跃基本信息
    , UpdataGuildGoalBasicData: "UpdataGuildGoalBasicData"
    , UpdataGuildGoalTaskData: "UpdataGuildGoalTaskData"
    , UpdataGuildGoalSingleTaskData: "UpdataGuildGoalSingleTaskData"

}